class ProductIngredients extends HTMLElement {
  constructor() {
    super();

    this.productInfo = document.querySelector('#product--info')
    this.button = this.querySelector('[choose-plan]')
    this.modalTrigger = this.querySelector('[modal-trigger]')
    this.titles = this.querySelectorAll('[ingredient-title]')
    this.onModalTrigger = this.onModalTrigger.bind(this)
  }

  connectedCallback() {
    this.modalTrigger?.addEventListener('click', this.onModalTrigger)
    this.titles.forEach(item => {
      item.addEventListener('click', () => {
        this.onClickTitle(item)
      }, false)
    })
  }


  onModalTrigger() {
    const modalId = this.modalTrigger.getAttribute('modal-id')
    document.querySelector(modalId).classList.add('Modal__Overlay--after-open')
  }

  onClickTitle(item) {
    const arrow = item.querySelector(".chevron-icon");
    arrow.classList.toggle("open");
    const answer = item.parentElement.querySelector('[ingredient-content]')
    if(answer.hasAttribute('hidden')) {
      answer.removeAttribute('hidden')
      answer.setAttribute('data-state', 'open')
      this.setAttribute('aria-expanded', 'true')
      item.parentElement.setAttribute('data-state', 'open')
    } else {
      answer.setAttribute('data-state', 'close')
      answer.setAttribute('hidden', '')
      this.setAttribute('aria-expanded', 'false')
      item.parentElement.setAttribute('data-state', 'close')
    }
  }
}

customElements.define('product-ingredients', ProductIngredients);
